import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

// A user's display name. WapStat is an English app, so always use the English
// `name` (the Dhivehi nameDv is ignored here).
export function displayName(u: { name: string; nameDv?: string | null }): string {
  return u.name;
}
